import { Col, Form, Icon, InputNumber, Row, Select } from "antd";
import React from "react";
import styles from './index.module.scss'

const typeOptions = () => [
  {
    value: "applicant_files",
    name: "Requisito por cantidad de archivos",
  },
];

const AdvancementRequitementField = ({
  form,
  identifier,
  restField = [],
  initialValues = null,
  remove,
  fileCategories,
}) => {
  const { getFieldDecorator } = form;

  return (
    <div>
      <Row type="flex" justify="space-around">
        <Col sm={{span: 9}} xs={24}>
          <Form.Item {...restField} label="Tipo de requerimiento" className={styles.labelField}>
            {getFieldDecorator(
              `applicant_requirement_required_type[${identifier}]`,
              {
                initialValue: "applicant_files",
                rules: [
                  { required: true, message: "Tipo de requisito requerido" },
                ],
              }
            )(
              <Select
                placeholder={"Tipo de requisito"}
                style={{ width: "100%" }}
              >
                {typeOptions().map((item) => (
                  <Select.Option
                    key={item.value}
                    label={`${item.name}` || ""}
                    value={item.value}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col sm={{span: 9, offset: 1}} xs={24}>
          <Form.Item {...restField} label="Seleccionar carpeta" className={styles.labelField}>
            {getFieldDecorator(
              `applicant_requirement_condition[${identifier}]`,
              {
                initialValue: initialValues?.condition,
                rules: [{ required: true, message: "Carpeta requerida" }],
              }
            )(
              <Select placeholder={"Seleccionar carpeta"} style={{ width: "100%" }}>
                {fileCategories.map((item) => (
                  <Select.Option
                    key={item.id}
                    label={`${item.name}` || ""}
                    value={item.name}
                  >
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col sm={{span: 3, offset: 1}} xs={{span: 22, offset: 1}}>
          <Form.Item {...restField} label="Valor" className={styles.labelField}>
            {getFieldDecorator(`applicant_requirement_value[${identifier}]`, {
              initialValue: initialValues?.value || 1,
              rules: [{ required: true, message: "Valor requerido" }],
            })(<InputNumber min={1} max={10} />)}
          </Form.Item>
        </Col>
        <Col span={1}>
          <Icon type="delete" onClick={() => remove(identifier)} className={styles.iconDelete}/>
        </Col>
      </Row>
    </div>
  );
};

export default AdvancementRequitementField;
